import { useLocation } from 'react-router-dom';
import { useCallback } from 'react';
import { TNavbarPage, useHasFeature } from '@diana/core';
import { useNavMenuItems } from './useNavMenuItems';
import { DianaFeaturesEnum } from '@diana/core/build/models/Core';

export function useIsActiveNavMenuItem() {
  const location = useLocation();
  const path = location.pathname;
  const { isNavMenuHidden } = useNavMenuItems();
  const hasToShowEntitiesOnWorkPage = !!useHasFeature(DianaFeaturesEnum.ShowAssetsOnWorkPage);

  return useCallback(
    (page: TNavbarPage) => {
      if (page.path === path) return true;
      const isUrlUnderWorkflows =
        path.split('/')[2]?.includes('workboard') || path.includes('work');
      const isUrlUnderThings = path.split('/')[2]?.includes('things');
      const isUrlUnderAssets = path.split('/')[2]?.includes('assets');
      const isUrlUnderThingDetails = path.split('/')[2]?.includes('thing');
      const isUrlUnderAssetDetails = path.split('/')[2]?.includes('asset');
      const isUrlUnderPerformance = path.split('/')[2]?.includes('performance');
      const isUrlUnderPeople = path.split('/')[2]?.includes('people');

      const isWorkflowsPage = page.path.split('/')[2]?.includes('workflows');
      const isThingsPage = page.path.split('/')[2]?.includes('things');
      const isAssetsPage = page.path.split('/')[2]?.includes('assets');
      const isThingDetailsPage = page.path.split('/')[2]?.includes('thing');
      const isAssetDetailsPage = page.path.split('/')[2]?.includes('asset');
      const isPerformancePage = page.path.split('/')[2]?.includes('performance');
      const isPeoplePage = page.path.split('/')[2]?.includes('people');

      const hasAssetPage = !isNavMenuHidden('assets');
      const isAssetPageOnWorkflowsPage =
        (isUrlUnderThings || isUrlUnderThingDetails) &&
        (isUrlUnderAssets || isUrlUnderAssetDetails) &&
        isWorkflowsPage &&
        !hasAssetPage &&
        hasToShowEntitiesOnWorkPage;

      return (
        (isUrlUnderWorkflows && isWorkflowsPage) ||
        (isUrlUnderThings && isThingsPage) ||
        (isUrlUnderThingDetails && isThingDetailsPage) ||
        (isUrlUnderAssets && isAssetsPage) ||
        (isUrlUnderAssetDetails && isAssetDetailsPage) ||
        (isUrlUnderPerformance && isPerformancePage) ||
        (isUrlUnderPeople && isPeoplePage) ||
        isAssetPageOnWorkflowsPage
      );
    },
    [hasToShowEntitiesOnWorkPage, isNavMenuHidden, path],
  );
}
